/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionForHomeFragmentDoc } from "../collections-list/CollectionsListTab2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionsForAddFromProjectQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  before: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
}>;

export type CollectionsForAddFromProjectQuery = {
  readonly __typename: "Query";
  readonly collections: {
    readonly __typename: "CollectionsConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "CollectionsEdge";
      readonly node: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly description: string | null;
        readonly emoji: string | null;
        readonly canManage: boolean;
        readonly starredByViewer: boolean;
        readonly collectionHexLinkCountsByProjectType: {
          readonly __typename: "LinkCountsByProjectType";
          readonly projectCount: number;
          readonly componentCount: number;
        };
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export const CollectionsForAddFromProjectDocument = /*#__PURE__*/ gql`
  query CollectionsForAddFromProject(
    $searchTerm: String
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
  ) {
    collections(
      searchTerm: $searchTerm
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...CollectionForHomeFragment
        }
      }
    }
  }
  ${CollectionForHomeFragmentDoc}
`;

/**
 * __useCollectionsForAddFromProjectQuery__
 *
 * To run a query within a React component, call `useCollectionsForAddFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsForAddFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsForAddFromProjectQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCollectionsForAddFromProjectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >(CollectionsForAddFromProjectDocument, options);
}
export function useCollectionsForAddFromProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >(CollectionsForAddFromProjectDocument, options);
}
export function useCollectionsForAddFromProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionsForAddFromProjectQuery,
    CollectionsForAddFromProjectQueryVariables
  >(CollectionsForAddFromProjectDocument, options);
}
export type CollectionsForAddFromProjectQueryHookResult = ReturnType<
  typeof useCollectionsForAddFromProjectQuery
>;
export type CollectionsForAddFromProjectLazyQueryHookResult = ReturnType<
  typeof useCollectionsForAddFromProjectLazyQuery
>;
export type CollectionsForAddFromProjectSuspenseQueryHookResult = ReturnType<
  typeof useCollectionsForAddFromProjectSuspenseQuery
>;
export type CollectionsForAddFromProjectQueryResult = Apollo.QueryResult<
  CollectionsForAddFromProjectQuery,
  CollectionsForAddFromProjectQueryVariables
>;
